import React, { useEffect, useState } from 'react';
import Menu from '../../../components/Menu';
import api from '../../../services/api';
import { useParams } from "react-router-dom";



function UsuariosEditar(props) {
    const { id } = useParams();

    const [usuario, setUsuario] = useState('');

    const [limiteDoc, setLimiteDoc] = useState('0');
    const [usadoDoc, setUsadoDoc] = useState('0');
    const [limiteDividas, setLimiteDividas] = useState('0');
    const [usadoDividas, setUsadoDividas] = useState('0');

    const [limiteNome, setLimiteNome] = useState('0');
    const [usadoNome, setUsadoNome] = useState('0');

    const [limiteTelefone, setLimiteTelefone] = useState('0');
    const [usadoTelefone, setUsadoTelefone] = useState('0');

    const [limiteEndereco, setLimiteEndereco] = useState('0');
    const [usadoEndereco, setUsadoEndereco] = useState('0');

    const [limiteEmail, setLimiteEmail] = useState('0');
    const [usadoEmail, setUsadoEmail] = useState('0');


    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    const [telefone, setTelefone] = useState('');
    const [obs, setObs] = useState('');
    const [cpf, setCpf] = useState('');

    const [dados, setDados] = useState({});
    const [senha, setSenha] = useState('');
    const [novaSenha, setNovaSenha] = useState('');
    const [confirmar, setConfirmar] = useState('');
    const [msg, setMsg] = useState('');
    const [trava, setTrava] = useState(true);

    const [valor, setValor] = useState('');
    const [periodo, setPeriodo] = useState('');
    const [formaPagamento, setFormaPagamento] = useState('');
    const [tipo, setTipo] = useState('');
    const [statuscheck, setStatusCheck] = useState('');
    const [dataPagamento, setDataPagamento] = useState('');


    useEffect(() => {
        async function getDados(id) {
            try {
                var dados = await api.get('/adm/usuarios/' + id);
                setTrava(false);
                setDados(dados.data);
                setUsuario(dados.data.usuario);
                setCpf(dados.data.cpf);
                setStatusCheck(dados.data.status);
                setNome(dados.data.nome);
                setEmail(dados.data.email);
                setTelefone(dados.data.telefone);
                setObs(dados.data.obs);

                setLimiteDoc(dados.data.limites.cpf_cnpj.limite ?? 0);
                setUsadoDoc(dados.data.limites.cpf_cnpj.usado ?? 0);

                setLimiteDividas(dados.data.limites.dividas?.limite ?? 0);
                setUsadoDividas(dados.data.limites.dividas?.usado ?? 0);

                setLimiteNome(dados.data.limites.nome.limite ?? 0);
                setUsadoNome(dados.data.limites.nome.usado ?? 0);

                setLimiteTelefone(dados.data.limites.telefone.limite ?? 0);
                setUsadoTelefone(dados.data.limites.telefone.usado ?? 0);

                setLimiteEndereco(dados.data.limites.endereco.limite ?? 0);
                setUsadoEndereco(dados.data.limites.endereco.usado ?? 0);


            } catch (e) {
                setTrava(true);
                console.log('error cath')
                var dados = '';
            }

        }
        getDados(id);
    }, [api, setDados, id]);

    if (!window.localStorage.getItem('token')) {
        window.location = './Sair';
        return;
    }

    const Editar = async (e, idfat) => {
        e.preventDefault(0);

        try {
            var result = await api.post('/adm/usuarios/' + idfat,
                {
                    usuario: usuario,
                    senha: senha,
                    status: statuscheck,
                    nome: nome,
                    cpf: cpf,
                    email: email,
                    telefone: telefone,
                    obs: obs,
                    cpf_cnpj_limite: limiteDoc,
                    cpf_cnpj_usado: usadoDoc,
                    dividas_limite: limiteDividas,
                    dividas_usado: usadoDividas,
                    nome_limite: limiteNome,
                    nome_usado: usadoNome,
                    telefone_limite: limiteTelefone,
                    telefone_usado: usadoTelefone,
                    endereco_limite: limiteEndereco,
                    endereco_usado: usadoEndereco
                }
            );
            if (result.data.msg) {
                setMsg(result.data.msg);
            }
        } catch (e) {
            setMsg('Ocorreu um erro interno, tente novamente mais tarde.');

        }

    }


    return (<div class="main-content" style={{ marginLeft: '0' }}>
        <Menu />
        <div id="page-wrapper">
            <div class="container">
                <div class="row">
                    <div class="col-md-4 col-md-offset-4" style={{ marginTop: '100px' }}>
                        <img src={'../public/assets/logoupbusca.png'} alt="Up Busca" class="center-block img-responsive" id="logo" style={{ marginTop: '-10%' }} />
                    </div>
                </div>
            </div>
            <div>

                {trava == false ? <div class="row">
                    <div class="col-md-10 col-md-offset-1">
                        <ul class="nav nav-tabs" role="tablist" style={{ marginTop: '0px' }}>
                            <li role="presentation" class="active">
                                <a href="#home" aria-controls="home" role="tab" data-toggle="tab" class="tab-result">Usuario #{id}</a>
                            </li>
                        </ul>

                        <div class="tab-content">
                            <div role="tabpanel" class="tab-pane active" id="home">
                                <div class="table-responsive" style={{ marginTop: '25px' }}>
                                    <div class="row">

                                        <div>
                                            <div class="form-group col-md-12">
                                                <span>Usuario:</span>
                                                <input type="text" disabled class="form-control" id="usuario" name="usuario" value={usuario} onChange={(e) => setUsuario(e.target.value)} />
                                            </div>

                                            <div class="form-group col-md-12">
                                                <span>Nova senha:</span>
                                                <input type="text" class="form-control" id="valor" name="valor" placeholder="" value={senha} onChange={(e) => setSenha(e.target.value)} />
                                            </div>
                                            <div class="form-group col-md-12">
                                                <span>Status:</span>
                                                <select value={statuscheck} onChange={(e) => setStatusCheck(e.target.value)} class="form-control">
                                                    <option value={1}>Ativo</option>
                                                    <option value={2}>Inativo</option>
                                                    <option value={3}>Bloqueado</option>
                                                </select>
                                            </div>
                                            <div class="form-group col-md-12">
                                                <span>Nome:</span>
                                                <input type="text" class="form-control" id="periodo" name="periodo" placeholder="" value={nome} onChange={(e) => setNome(e.target.value)} />
                                            </div>

                                            <div class="form-group col-md-12">
                                                <span>CPF:</span>
                                                <input type="text" class="form-control" id="datapg" name="datapg" placeholder="" value={cpf} onChange={(e) => setCpf(e.target.value)} />
                                            </div>

                                            <div class="form-group col-md-12">
                                                <span>E-mail:</span>
                                                <input type="text" class="form-control" id="datapg" name="datapg" placeholder="" value={email} onChange={(e) => setEmail(e.target.value)} />
                                            </div>

                                            <div class="form-group col-md-12">
                                                <span>Telefone:</span>
                                                <input type="text" class="form-control" id="datapg" name="datapg" placeholder="" value={telefone} onChange={(e) => setTelefone(e.target.value)} />
                                            </div>

                                            <div class="form-group col-md-12">
                                                <span>Obs:</span>
                                                <textarea class="form-control" value={obs} onChange={(e) => setObs(e.target.value)}>
                                                </textarea>
                                            </div>

                                            <div className='row'>
                                                <div className='col'>
                                                    <div class="form-group col-md-4">
                                                        <span>Serviço:</span>
                                                        <input type="text" style={{height: '25px'}} disabled class="form-control" id="usuario" name="usuario" value={`CPF/CNPJ`} onChange={(e) => setUsuario(e.target.value)} />
                                                    </div>
                                                    <div class="form-group col-md-4">
                                                        <span>Limite CPF/CNPJ:</span>
                                                        <input type="text" style={{height: '25px'}} class="form-control" id="limiteDoc" name="limiteDoc" value={limiteDoc} onChange={(e) => setLimiteDoc(e.target.value)} />
                                                    </div>
                                                    <div class="form-group col-md-4">
                                                        <span>Usado CPF/CNPJ:</span>
                                                        <input type="text" style={{height: '25px'}} class="form-control" id="usadoDoc" name="usadoDoc" value={usadoDoc} onChange={(e) => setUsadoDoc(e.target.value)} />
                                                    </div>
                                                </div>
                                                <div className='col'>
                                                    <div class="form-group col-md-4">
                                                        <span>Serviço:</span>
                                                        <input type="text" style={{height: '25px'}} disabled class="form-control" id="usuario" name="usuario" value={`Dividas`} />
                                                    </div>
                                                    <div class="form-group col-md-4">
                                                        <span>Limite Dividas:</span>
                                                        <input type="text" style={{height: '25px'}} class="form-control" id="limiteDividas" name="limiteDividas" value={limiteDividas} onChange={(e) => setLimiteDividas(e.target.value)} />
                                                    </div>
                                                    <div class="form-group col-md-4">
                                                        <span>Usado Dividas:</span>
                                                        <input type="text" style={{height: '25px'}} class="form-control" id="usadoDividas" name="usadoDividas" value={usadoDividas} onChange={(e) => setUsadoDividas(e.target.value)} />
                                                    </div>
                                                </div>
                                                <div className='col'>
                                                    <div class="form-group col-md-4">
                                                        <span>Serviço:</span>
                                                        <input type="text" style={{height: '25px'}} disabled class="form-control" id="usuario" name="usuario" value={`Nome`} />
                                                    </div>
                                                    <div class="form-group col-md-4">
                                                        <span>Limite Nome:</span>
                                                        <input type="text" style={{height: '25px'}} class="form-control" id="limiteNome" name="limiteNome" value={limiteNome} onChange={(e) => setLimiteNome(e.target.value)} />
                                                    </div>
                                                    <div class="form-group col-md-4">
                                                        <span>Usado Nome:</span>
                                                        <input type="text" style={{height: '25px'}} class="form-control" id="usadoDoc" name="usadoNome" value={usadoNome} onChange={(e) => setUsadoNome(e.target.value)} />
                                                    </div>
                                                </div>
                                                <div className='col'>
                                                    <div class="form-group col-md-4">
                                                        <span>Serviço:</span>
                                                        <input type="text" style={{height: '25px'}} disabled class="form-control" id="usuario" name="usuario" value={`Telefone/Email`} />
                                                    </div>
                                                    <div class="form-group col-md-4">
                                                        <span>Limite Telefone/E-mail:</span>
                                                        <input type="text" style={{height: '25px'}} class="form-control" id="limiteTelefone" name="limiteTelefone" value={limiteTelefone} onChange={(e) => setLimiteTelefone(e.target.value)} />
                                                    </div>
                                                    <div class="form-group col-md-4">
                                                        <span>Usado Telefone/E-mail:</span>
                                                        <input type="text" style={{height: '25px'}} class="form-control" id="usadoTelefone" name="usadoTelefone" value={usadoTelefone} onChange={(e) => setUsadoTelefone(e.target.value)} />
                                                    </div>
                                                </div>
                                                <div className='col'>
                                                    <div class="form-group col-md-4">
                                                        <span>Serviço:</span>
                                                        <input type="text" style={{height: '25px'}} disabled class="form-control" id="usuario" name="usuario" value={`Endereço`} />
                                                    </div>
                                                    <div class="form-group col-md-4">
                                                        <span>Limite Endereço:</span>
                                                        <input type="text" style={{height: '25px'}} class="form-control" id="limiteEndereco" name="limiteEndereco" value={limiteEndereco} onChange={(e) => setLimiteEndereco(e.target.value)} />
                                                    </div>
                                                    <div class="form-group col-md-4">
                                                        <span>Usado Endereço:</span>
                                                        <input type="text" style={{height: '25px'}} class="form-control" id="usadoEndereco" name="usadoEndereco" value={usadoEndereco} onChange={(e) => setUsadoEndereco(e.target.value)} />
                                                    </div>
                                                </div>
                                                {/* <div className='col'>
                                                    <div class="form-group col-md-4">
                                                        <span>Serviço:</span>
                                                        <input type="text" style={{height: '25px'}} disabled class="form-control" id="usuario" name="usuario" value={`E-mail`} />
                                                    </div>
                                                    <div class="form-group col-md-4">
                                                        <span>Limite E-mail:</span>
                                                        <input type="text" style={{height: '25px'}} class="form-control" id="limiteEmail" name="limiteEmail" value={limiteEmail} onChange={(e) => setLimiteEmail(e.target.value)} />
                                                    </div>
                                                    <div class="form-group col-md-4">
                                                        <span>Usado E-mail:</span>
                                                        <input type="text" style={{height: '25px'}} class="form-control" id="usadoEmail" name="usadoEmail" value={usadoEmail} onChange={(e) => setUsadoEmail(e.target.value)} />
                                                    </div>
                                                </div> */}
                                            </div>
                                            




                                            <div className='form-groud col-md-12'>
                                                {msg.length > 0 ? <center>{msg}</center> : ''}

                                                <br />
                                                <center>
                                                    <button id="btAtualizarSenha" type="button" onClick={(e) => Editar(e, id)} class="btn btn-primary">Editar usuario</button>
                                                    <button style={{ marginLeft: '10px' }} id="btVoltar" type="button" onClick={(e) => window.history.go(-1)} class="btn btn-dark">Voltar</button>
                                                </center>
                                            </div>

                                        </div>
                                        <br />
                                    </div>
                                    <br />
                                </div>
                            </div>
                        </div>
                    </div>
                </div> : (``)}


            </div>

        </div></div>);
}

export default UsuariosEditar;
